import Finxact from '../assets/Finxact.png';
import ThoughtMachine from '../assets/ThoughtMachine.png';
import Finzly from '../assets/Finzly.png';
import guidewire from '../assets/Guidewire.png';
import Maximo from '../assets/Maximo.png';
import salesforce from '../assets/Salesforce.png';
import Technisys from '../assets/Technisys.png';
import workday from '../assets/Workday.png';

const ConnectorConfigs: { [key: string]: { img: string } } = {
  salesforce: {
    img: salesforce
  },
  finxact: {
    img: Finxact
  },
  finzly: {
    img: Finzly
  },
  technisys: {
    img: Technisys
  },
  maximo: {
    img: Maximo
  },
  guidewire: {
    img: guidewire
  },
  workday: {
    img: workday
  },
  thoughtmachine: {
    img: ThoughtMachine
  }
};

export default ConnectorConfigs;
